export const ILlUploadDragProps = {
  value: {
    type: Array,
    default: () => []
  },
  tip: {
    type: String,
    default: ''
  },
  accept: {
    type: String,
    default: ''
  },
  fileSize: {
    type: Number,
    default: null
  },
  multiple: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
}
